import { useDeviceStore } from '~/store/device';
import { DESKTOP, TABLET } from '~/constants';

export default defineNuxtPlugin(() => {
  const deviceStore = useDeviceStore();

  function handleResize() {
    const isMobile = window.matchMedia(`(max-width: ${TABLET - 1}px)`);
    const isTablet = window.matchMedia(
      `(min-width: ${TABLET}px) and (max-width: ${DESKTOP - 1}px)`,
    );
    const isDesktop = window.matchMedia(`(min-width: ${DESKTOP}px)`);

    const deviceInfo = {
      isMobile: isMobile.matches,
      isTablet: isTablet.matches,
      isDesktop: isDesktop.matches,
    };

    deviceStore.setDevice(deviceInfo);
  }

  onNuxtReady(async () => {
    handleResize();
    window.addEventListener('resize', handleResize, { passive: true });
  });
});
